<template>
  <div class="page flex-col">
    <div class="block_1 flex-col">
      <div class="box_1 flex-col">
        <div class="group_1 flex-row">
          <img
            class="label_1"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
          />
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG1aeb0cd94a717356e83336886e3e56ba.png')"
          />
          <span class="text_1">首页</span>
          <span class="text_2">解决方案</span>
          <span class="text_3">康复助手</span>
          <span class="text_4">产品介绍</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGa14a240930f6ce8957ded5645604cdd7.png')"
          />
          <span class="text_5">功能及报价</span>
          <span class="text_6">关于我们</span>
          <div class="group_2 flex-row">
            <span class="text_7">登录</span>
            <div class="section_1 flex-col"></div>
          </div>
        </div>
      </div>
      <div class="image-wrapper_1 flex-row justify-between">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG09cb983dcfff56fe852a4569159ebb64.png')"
        />
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGad465eb1db4df41e085b8b25c44b203d.png')"
        />
      </div>
      <span class="text_8">开运动处方找以动就够了</span>
      <div class="box_2 flex-col">
        <div class="text-wrapper_1 flex-col"><span class="text_9">免费使用</span></div>
      </div>
      <span class="text_10">开运动处方找以动就够了</span>
      <div class="text-wrapper_2 flex-col">
        <span class="text_11">运动处方系统及本地化工作站</span>
        <span class="text_12">功复道&nbsp;&nbsp;&nbsp;PF-E26</span>
        <span class="text_13">健康体适能测评仪</span>
        <span class="text_14">人体成分分析仪</span>
        <span class="text_15">全身有氧训练机（前摆臂）IC7006</span>
        <span class="text_16">全身线性有氧健身机&nbsp;IC7007</span>
        <span class="text_17">全身脑部肢体协调训练机&nbsp;IC7009</span>
      </div>
    </div>
    <div class="block_2 flex-col">
      <div class="text-wrapper_3">
        <span class="text_18">通用医疗</span>
        <span class="text_19">运动处方工作站</span>
      </div>
      <span class="text_20">适用大型医院、机构、养老产业</span>
      <div class="box_3 flex-col align-center">
        <div class="box_4 flex-col">
          <div class="text-wrapper_4 flex-col"><span class="text_21">了解更多</span></div>
        </div>
      </div>
    </div>
    <div class="block_3 flex-col">
      <div class="text-group_1 flex-col justify-between">
        <span class="text_22">便携式工作站</span>
        <span class="text_23">适用大型社区、康复中心、健康管理机构</span>
      </div>
      <div class="text-wrapper_5 flex-col"><span class="text_24">了解更多</span></div>
      <img
        class="image_4"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNGe50de8b3df82349da24df50f6310d2b2.png')"
      />
    </div>
    <div class="block_4 flex-col">
      <div class="text-group_2 flex-col justify-between">
        <span class="text_25">web端康复助手</span>
        <span class="text_26">个人康复治疗师、健身房、私人康复工作室</span>
      </div>
      <div class="text-wrapper_6 flex-col"><span class="text_27">了解更多</span></div>
      <div class="group_3 flex-row justify-between">
        <div class="group_4 flex-col"></div>
        <div class="group_5 flex-col"></div>
      </div>
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNGde6ce13823ca81734facefbeb51eebf8.png')"
      />
    </div>
    <div class="block_5 flex-col">
      <div class="text-wrapper_7">
        <span class="text_28">通用医疗</span>
        <span class="text_29">运动处方工作站</span>
        <span class="paragraph_1">
          (GMEPS)
          <br />
        </span>
        <span class="text_30">搭载运动处方数据库和系统</span>
      </div>
      <div class="text-wrapper_8 flex-col"><span class="text_31">了解更多</span></div>
      <div class="image-text_1 flex-col justify-between">
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGc3dea7fc88fda826ff655d07545eb417.png')"
        />
        <span class="text-group_3">系统及工作站</span>
      </div>
      <div class="text-wrapper_9 flex-col"><span class="text_32">数据中心及系统</span></div>
      <img
        class="image_7"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNG0b99f6a2447202a301aaeea69eed48cb.png')"
      />
      <div class="block_6 flex-row">
        <span class="paragraph_2">
          报
          <br />
          告
          <br />
          输
          <br />
          出
        </span>
        <div class="section_2 flex-col"></div>
        <span class="paragraph_3">
          实
          <br />
          时
          <br />
          共
          <br />
          享
        </span>
        <span class="paragraph_4">
          命
          <br />
          令
          <br />
          下
          <br />
          达
        </span>
        <div class="section_3 flex-col"></div>
        <span class="paragraph_5">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
        <span class="paragraph_6">
          实
          <br />
          时
          <br />
          连
          <br />
          接
        </span>
        <div class="section_4 flex-col"></div>
        <span class="paragraph_7">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
        <span class="paragraph_8">
          处
          <br />
          方
          <br />
          下
          <br />
          达
        </span>
        <div class="section_5 flex-col"></div>
        <span class="paragraph_9">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
      </div>
      <div class="block_7 flex-row">
        <div class="text-wrapper_10 flex-col"><span class="text_33">患者端小程序</span></div>
        <div class="group_6 flex-col"></div>
        <div class="text-wrapper_11 flex-col"><span class="text_34">运动中的安全设备</span></div>
        <div class="text-wrapper_12 flex-col"><span class="text_35">运动设备</span></div>
      </div>
      <div class="image-wrapper_2 flex-row">
        <img
          class="image_8"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG76b5cec0ba6cd1ae5ddab11d0fe2ba92.png')"
        />
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG6d6b11e2cd3005ee53817234239218f6.png')"
        />
        <img
          class="image_10"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG8a221a3707eea39e2c556cc239008dc7.png')"
        />
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG7f6189f56e22d5f5050bff40f96f9408.png')"
        />
      </div>
      <div class="text-wrapper_13 flex-row">
        <span class="paragraph_10">
          患者手机端康复小程序
          <br />
          实时上传患者数据及查看运动处方
        </span>
        <span class="text_36">体适能评估和关节角度评估设备</span>
        <span class="text_37">心率监控手环等</span>
        <span class="text_38">功率车和四肢联动设备等</span>
      </div>
      <div class="block_8 flex-col"></div>
      <div class="block_9 flex-col"></div>
      <div class="block_10 flex-col"></div>
      <div class="block_11 flex-col"></div>
      <span class="text_39">评估设备</span>
    </div>
    <div class="block_12 flex-col">
      <img
        class="image_12"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNG2f6b66d68bbf1e0d9ae2e8add6d8383d.png')"
      />
      <div class="text-wrapper_14">
        <span class="text_40">康复</span>
        <span class="text_41">病历</span>
        <span class="text_42">助手</span>
      </div>
      <div class="text-group_4 flex-col justify-between">
        <div class="text-wrapper_15">
          <span class="paragraph_11">
            历时4年
            <br />
          </span>
          <span class="text_43">20余位中美专家</span>
          <span class="paragraph_12">
            研发
            <br />
          </span>
          <span class="text_44">30家顶尖医院</span>
          <span class="text_45">临床验证</span>
        </div>
        <div class="text-wrapper_16">
          <span class="text_46">2000</span>
          <span class="paragraph_13">
            位治疗师使用
            <br />
          </span>
          <span class="text_47">20000</span>
          <span class="text_48">位患者受益</span>
        </div>
      </div>
      <div class="box_5 flex-col">
        <div class="text-wrapper_17">
          <span class="text_49">著名三甲</span>
          <span class="text_50">医院专科和私立康复</span>
          <span class="text_51">机构的选择</span>
        </div>
        <div class="image-wrapper_3 flex-row justify-between">
          <img
            class="image_13"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG1794e752389f3226c85d95c381f8d3b4.png')"
          />
          <img
            class="image_14"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGa98c8059fce28fb99b7d4859de05bae6.png')"
          />
          <img
            class="image_15"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG0d3155482386ab4c828b2e9d733ddd6b.png')"
          />
        </div>
        <div class="text-wrapper_18 flex-row justify-between">
          <span class="text_52">中日友好医院</span>
          <span class="text_53">北京大兴清源路街道养老社区</span>
          <span class="text_54">北京聚陆医疗</span>
        </div>
      </div>
      <div class="text-wrapper_19">
        <span class="text_55">运动处方</span>
        <span class="text_56">数据参考来源</span>
      </div>
      <div class="image-wrapper_4 flex-row justify-between">
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG094c8a0b91b09f5dbfbdab89afc886fe.png')"
        />
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGc9197906aeff173ae861090ce8f65f5a.png')"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG469a7ccfe6af7daa095a79d9be106075.png')"
        />
      </div>
      <div class="text-wrapper_20 flex-row">
        <span class="text_57">美国运动医学会</span>
        <span class="text_58">美国物理治疗师协会</span>
        <span class="text_59">世界物理治疗师协会</span>
      </div>
      <div class="box_6 flex-col">
        <div class="text-wrapper_21">
          <span class="text_60">三大</span>
          <span class="paragraph_14">
            核心功能
            <br />
          </span>
          <span class="text_61">为您的患者</span>
          <span class="text_62">定制运动康复计划</span>
        </div>
        <div class="list_1 flex-row">
          <div class="list-items_1 flex-col justify-between" v-for="(item, index) in loopData0" :key="index">
            <img class="image_19" referrerpolicy="no-referrer" :v-lazy="item.lanhuimage0" />
            <div class="text-wrapper_22">
              <span class="text_63" v-html="item.lanhutext0"></span>
              <span class="text_64" v-html="item.lanhutext1"></span>
              <span class="text_65" v-html="item.lanhutext2"></span>
            </div>
          </div>
        </div>
        <div class="box_7 flex-col"></div>
        <div class="box_8 flex-row">
          <div class="text-wrapper_23">
            <span class="paragraph_15">
              患者通过小程序
              <br />
              接受指令
              <br />
            </span>
            <span class="text_66">完成评估和康复计划</span>
          </div>
          <div class="block_13 flex-col"></div>
          <div class="block_14 flex-col"></div>
        </div>
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGe26f3fbb88a0d576fb75870d838da5fe.png')"
        />
      </div>
      <div class="box_9 flex-col"></div>
      <div class="box_10 flex-col">
        <div class="text-wrapper_24">
          <span class="paragraph_16">
            处方数据库
            <br />
          </span>
          <span class="text_67">康复计划来自临床验证</span>
        </div>
        <div class="group_7 flex-row justify-between">
          <div class="text-group_5 flex-col justify-between">
            <span class="text_68">3000+</span>
            <span class="text_69">不同运动方式模块</span>
          </div>
          <div class="text-wrapper_25 flex-col justify-between">
            <span class="text_70">200+</span>
            <span class="text_71">骨科运动康复评估方法</span>
          </div>
        </div>
        <div class="group_8 flex-row justify-between">
          <div class="text-group_6 flex-col justify-between">
            <span class="text_72">50+</span>
            <span class="paragraph_17">
              骨科、三高慢性病精神疾病
              <br />
              康复方案及相关数字疗法软件
            </span>
          </div>
          <div class="text-group_7 flex-col justify-between">
            <span class="text_73">70+</span>
            <span class="text_74">肌肉群组的训练及拉伸</span>
          </div>
        </div>
      </div>
    </div>
    <div class="block_15 flex-col">
      <div class="image-wrapper_5 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG62502f655eccbcec3e5735ba277fd3ba.png')"
        />
      </div>
      <div class="box_11 flex-row">
        <div class="box_12 flex-col justify-between">
          <div class="text-wrapper_26 flex-row justify-between">
            <span class="text_75">联系方式：13220190868</span>
            <span class="text_76">Email：info&#64;ktangtang.com</span>
          </div>
          <span class="text_77">官网地址：https://ktangtang.com</span>
          <span class="text_78">公司地址：&nbsp;北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        </div>
        <div class="text-wrapper_27 flex-col justify-between">
          <span class="text_79">公众号：以动健康</span>
          <span class="text_80">官方微博：&#64;以动健康</span>
          <span class="text_81">京ICP备19026627号</span>
        </div>
        <div class="image-text_2 flex-col justify-between">
          <img
            class="image_22"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.png')"
          />
          <span class="text-group_8">公众号二维码</span>
        </div>
      </div>
    </div>
    <div class="block_16 flex-col">
      <div class="box_13 flex-row justify-between">
        <img
          class="image_23"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG865f2cd1786fc2a8bc8fb883d4c6af01.png')"
        />
        <div class="section_6 flex-col"></div>
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG09c7b252d09de66d4126ddc837fb7b30.png')"
        />
        <span class="text_82">四大特点</span>
      </div>
      <div class="box_14 flex-row justify-between">
        <div class="group_9 flex-col">
          <div class="image-text_3 flex-col justify-between">
            <img
              class="image_25"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG23a3f3cbaa5c5cf5abfdfded555b02b9.png')"
            />
            <span class="text-group_9">开具运动处方及教育</span>
          </div>
          <span class="text_83">我们提供运动处方工具软件和平台，全面辅助您开具运动处方，增加患者使用效果和粘性。</span>
        </div>
        <div class="group_10 flex-col">
          <div class="image-text_4 flex-col justify-between">
            <img
              class="image_26"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG98fd649ed6478278a07d315c051ca4ab.png')"
            />
            <span class="text-group_10">经过临床验证</span>
          </div>
          <span class="paragraph_18">
            产品有效性经过临床实验，证明可以增加康复效果和用户粘性。
            <br />
          </span>
        </div>
        <div class="group_11 flex-col">
          <div class="image-text_5 flex-col justify-between">
            <img
              class="image_27"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG300885673b2e57d8f77e31fd47eaf063.png')"
            />
            <span class="text-group_11">最新运动处方知识</span>
          </div>
          <span class="text_84">核心运动处方知识库根据循证医学体系建立，收集最新运动康复相关专业知识。</span>
        </div>
        <div class="group_12 flex-row">
          <div class="image-text_6 flex-col justify-between">
            <img
              class="image_28"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9212e6b20a72bb4431431658bfd35e3a.png')"
            />
            <div class="text-group_12 flex-col justify-between">
              <span class="paragraph_19">
                智慧化运动处方
                <br />
                “整屋定制”
              </span>
              <span class="text_85">
                开运动处方，提供一站式的基于物联网康复设备的解决方案，如可定制的系统及设备选择，场地及服务流程的梳理等。
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loopData0: [
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNG3e8176820a0259d93d6d60540e595da7.png',
          lanhutext0: '康复',
          lanhutext1: '评估',
          lanhutext2: '助手'
        },
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNG8a69054cc4d57ccc69f029fced903d73.png',
          lanhutext0: '康复',
          lanhutext1: '处方',
          lanhutext2: '助手'
        }
      ],
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />